export enum ColumnFormat {
  NONE = null,
  TEXTAREA = 'TEXTAREA',
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  TIME = 'TIME',
  NUMBER = 'NUMBER',
  CURRENCY = 'CURRENCY',
  AMOUNTEUR = 'AMOUNTEUR',
  LENGTH = 'LENGTH',
  BOOLEAN = 'BOOLEAN',
  CHECK = 'CHECK',
  SELECT = 'SELECT',
  MULTISELECT = 'MULTISELECT',
  MULTISELECT_ARRAY = 'MULTISELECT_ARRAY',
  ICON = 'ICON',
  ICONFROMVALUE = 'ICONFROMVALUE',
  HTML = 'HTML',
  HTMLVIEW = 'HTMLVIEW',
  BUTTON = 'BUTTON',
  ACTIONICON = 'ACTIONICON',
  STATUS = 'STATUS',
  ORGASTATUS = 'ORGASTATUS',
  CUSTOMERSTATUS = 'CUSTOMERSTATUS',
  PAYMENTSTATUS = 'PAYMENTSTATUS',
  ACTIVATIONSTATUS = 'ACTIVATIONSTATUS',
}
